import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

interface IRefUser {
    id: string
    name?: string
    thumbnail?: string
}

export const getUsedMyRefCode = async (id: string): Promise<ApiRes<IRefUser[]>> => {
    return await apiGet(API_URL, `admin/user/ref/${id}`)
}
